import React, {Component} from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
//import Select from 'react-select'
import ButtonIcon from "../../../button";
class AdminBarGraph extends Component {
    render(){
        return(
            <div>
                <h1>{this.props.title}</h1>
                {/*<Select id="usageMonthSelect"*/}
                {/*    options={this.props.usageMonthOptions}*/}
                {/*/>*/}
                <div>
                    <ButtonIcon onClick={()=>alert("click")} iconLeft="file-excel" iconSize="17px" customClassName="header-filter-button" labelName="Export to excel"/> 
                </div>
                <BarChart width={600} height={300} data={this.props.data}>
                    <CartesianGrid vertical={false}  stroke="#ccc" />
                    <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{fontSize: 13, fill: '#919eab'}} />
                    <YAxis width={60} tickLine={false} axisLine={false} tick={{fontSize: 13, fill: '#919eab'}} paddingBottom={20}/>
                    <Tooltip />
                    <Legend />
                    {this.props.ledger.map((dataKey,index)=>
                    <Bar key={index} dataKey={dataKey.name} fill={dataKey.color} radius={20} barSize={10}/>
                    )}
                </BarChart>
            </div>         
        )
    }
}

export default AdminBarGraph;